// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// Pure "best score vs the forge's record" derivation.
// PRD §Implementation Decisions `forge-record-score` aggregate; US §10;
// issue `fe-dashboard-data-layer` — "typed selectors — ... forge record accessors".
// Already-fetched data in (cycle's current best score + `ForgeDetailsDto.best_score`),
// a comparison out — no fetch (INV-3).

import { isFiniteNumber } from "./number-guards"

export interface ForgeRecordComparison {
  // null when no cycle has settled a score yet.
  record: number | null
  // null when not yet known.
  current: number | null
  // null unless both are known, never NaN/fabricated 0.
  delta: number | null
  // true only when both are known and current strictly beats record.
  isNewRecord: boolean
}

export const compareToForgeRecord = (
  currentBestScore: number | null | undefined,
  forgeBestScore: number | null | undefined,
): ForgeRecordComparison => {
  const record = isFiniteNumber(forgeBestScore) ? forgeBestScore : null
  const current = isFiniteNumber(currentBestScore) ? currentBestScore : null
  const delta = record != null && current != null ? current - record : null

  return {
    record,
    current,
    delta,
    isNewRecord: delta != null && delta > 0,
  }
}
